<template>
  <div ref="annulusPanel" class="annulus"></div>
</template>
<script>
import * as echarts from "echarts";
import { debounce } from "lodash";
export default {
  name: "HistogramPanel",
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    seriesData: {
      immediate: true,
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          const element = newVal[i];
          this.option.series[0].data[i].value = element.value;
          this.option.series[0].data[i].name = element.name;
        }
        this.chartInstance?.setOption(this.option);
      }
    },
    // 监听 option 变化并更新图表
    option: {
      handler(newOption) {
        this.chartInstance?.setOption(newOption);
      },
      deep: true,
    },
  },
  data() {
    return {
      myChart: null,
      chartInstance: null,
      option: {
        color: ["#5470c6", "#00f6ff"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "center",
          right: "10%",
          orient: "vertical",
          itemGap: 25,
          textStyle: {
            color: "#ffffff",
          },
        },
        series: [
          {
            name: this.$t("screen.driverNumber"),
            type: "pie",
            center: ["30%", "50%"],
            radius: ["47%", "75%"],
            avoidLabelOverlap: false,
            clockwise: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              scaleSize: 15,
              label: {
                formatter: "{b}\n{d}%",
                show: true,
                fontSize: 20,
                color: "#ffffff",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 823,
                name: "在线占比",
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#025ee2" }, // 起始颜色
                      { offset: 1, color: "#00f3fd" }, // 结束颜色
                    ],
                  },
                },
              },
              {
                value: 177,
                name: "离线占比",
                itemStyle: {
                  color: "#154a91",
                },
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    this.chartInstance?.dispose();
  },
  methods: {
    initChart() {
      for (let i = 0; i < this.seriesData.length; i++) {
        const element = this.seriesData[i];
        this.option.series[0].data[i].value = element.value;
        this.option.series[0].data[i].name = element.name;
      }
      if (!this.$refs.annulusPanel) return;
      this.chartInstance = echarts.init(this.$refs.annulusPanel);
      this.chartInstance.setOption(this.option);
      this.$emit("ready");
    },
    resizeChart: debounce(function () {
      this.chartInstance?.resize();
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>